import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth, useTheme } from '../../context/AppContext';
import {
  LayoutDashboard, Building2, Users, ShieldCheck, UserCheck,
  LogOut, Sun, Moon, Menu, X, Shield, Bell, KeyRound
} from 'lucide-react';

const superAdminNav = [
  { label: 'Overview',          to: '/superadmin/dashboard',        icon: LayoutDashboard },
  { label: 'Panels',            to: '/superadmin/panels',           icon: Building2 },
  { label: 'Admins',            to: '/superadmin/admins',           icon: Users },
  { label: 'Permission Types',  to: '/superadmin/permission-types', icon: KeyRound },
  { label: 'API Keys',          to: '/superadmin/api-keys',         icon: KeyRound },
];

const adminNav = [
  { label: 'Overview',   to: '/admin/dashboard',  icon: LayoutDashboard },
  { label: 'Modules',    to: '/admin/modules',    icon: KeyRound },
  { label: 'Roles',      to: '/admin/roles',      icon: ShieldCheck },
  { label: 'Employees',  to: '/admin/employees',  icon: UserCheck },
];

export default function Layout({ children, sidebarOpen, setSidebarOpen }) {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const nav = user?.userType === 'superadmin' ? superAdminNav : adminNav;
  const initials = user?.name?.split(' ')?.map(n => n[0])?.join('')?.slice(0,2).toUpperCase() || 'U';

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="app-shell">
      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? '' : 'collapsed'}`}>
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">
            <Shield size={20} color="white" />
          </div>
          <div>
            <div className="sidebar-logo-text">AdminHub</div>
            <div className="sidebar-logo-sub">
              {user?.userType === 'superadmin' ? 'Super Admin' : user?.role_type || 'Admin'}
            </div>
          </div>
        </div>

        <nav className="sidebar-nav">
          <div className="sidebar-section-label">Navigation</div>
          {nav.map(({ label, to, icon: Icon }) => (
            <NavLink key={to} to={to} className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}>
              <Icon className="sidebar-item-icon" size={17} />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="user-avatar">{initials}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="user-name" style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                {user?.name}
              </div>
              <div className="user-role">{user?.email}</div>
            </div>
          </div>
          <button className="btn btn-ghost w-full mt-2" style={{ justifyContent:'flex-start' }} onClick={handleLogout}>
            <LogOut size={15} /> Sign out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="main-content">
        {/* Topbar */}
        <header className="topbar">
          <div className="topbar-left">
            <button className="icon-btn" onClick={() => setSidebarOpen(o => !o)}>
              {sidebarOpen ? <X size={17} /> : <Menu size={17} />}
            </button>
            <div>
              <div className="topbar-title">
                {user?.userType === 'superadmin' ? 'Super Admin Console' : `${user?.role_type === 'panel_admin' ? 'Panel Admin' : 'Manage Admin'} Panel`}
              </div>
            </div>
          </div>
          <div className="topbar-right">
            <button className="icon-btn" title="Toggle theme" onClick={toggleTheme}>
              {theme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
            </button>
            <button className="icon-btn"><Bell size={16} /></button>
            <div className="user-avatar" style={{ width:34, height:34, fontSize:'.78rem', cursor:'default' }}>
              {initials}
            </div>
          </div>
        </header>

        <div className="page-content">{children}</div>
      </main>
    </div>
  );
}
